export const handlAuthUserType = (dispatch, payload) => {
  dispatch({ type: 'USER_TYPE', payload });
};

export const handlAuthMobile = (dispatch, payload) => {
  dispatch({ type: 'MOBILE', payload });
};

export const handlAuthSid = (dispatch, payload) => {
  dispatch({ type: 'SID', payload });
};

export const handlAuthSelectedBusiness = (dispatch, payload) => {
  dispatch({ type: 'SELECTED_BUSINESS', payload });
};

export const handlAuthUserDetails = (dispatch, payload) => {
  dispatch({ type: 'USER_DETAILS', payload });
};

export const handlAuthAllBusinesses = (dispatch, payload) => {
  dispatch({ type: 'ALL_BUSINESSES', payload });
};

export const handleResendTimer = (dispatch, payload) => {
  dispatch({ type: 'RESEND_TIMER', payload });
};

export const handleProfileDetails = (dispatch, payload) => {
  dispatch({ type: 'SET_PROFILE_DETAILS', payload });
};
